import axios from "axios";
import { local, session } from "./storage";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const ORIGIN = typeof window !== "undefined" ? window.location.origin : ENV_URL;
const FALLBACK_KEY = "theater_api_origin_fallback";

let BACKEND_URL = ENV_URL;
if (session.get(FALLBACK_KEY) === "1" && ORIGIN !== ENV_URL) BACKEND_URL = ORIGIN;

export const getBackendUrl = () => BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = local.get("theater_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// If the configured backend host is unreachable (e.g. custom domain DNS not ready), retry via the current origin.
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const unreachable = !error.response && error.code !== "ERR_CANCELED";
  if (unreachable && !cfg._originRetry && BACKEND_URL !== ORIGIN && ORIGIN.startsWith("http")) {
    BACKEND_URL = ORIGIN;
    api.defaults.baseURL = `${ORIGIN}/api`;
    session.set(FALLBACK_KEY, "1");
    return api.request({ ...cfg, baseURL: api.defaults.baseURL, _originRetry: true });
  }
  return Promise.reject(error);
});

export default api;

export const fileUrl = (urlOrId) => {
  if (!urlOrId) return "";
  if (urlOrId.startsWith("http")) return urlOrId;
  if (urlOrId.startsWith("/api")) return `${BACKEND_URL}${urlOrId}`;
  return urlOrId;
};
